/* ========================================================
   ROYAL EXPRESS — ULTRA-CLEAN DTC SHOPIFY THEME LOGIC
   Plus Jakarta Sans • Rectangular Color Cards • Dynamic Gallery • COD Modal
   ======================================================== */

document.addEventListener('DOMContentLoaded', () => {
  // Galleries per color (loaded from Liquid CDN URLs or local fallback)
  const defaultGalleries = {
    'Blanco-negro': [
      { src: 'shoe_blanco_negro.webp', label: 'Lateral' },
      { src: 'blanco_negro_pair.webp', label: 'Con Suela' },
      { src: 'blanco_negro_angle.webp', label: 'Dinámico' },
      { src: 'blanco_negro_top.webp', label: 'Superior' },
      { src: 'blanco_negro_heel.webp', label: 'Talón' }
    ],
    'Blanco-azul': [
      { src: 'shoe_blanco_azul.webp', label: 'Lateral' },
      { src: 'blanco_azul_pair.png', label: 'Con Suela' },
      { src: 'blanco_azul_angle.png', label: 'Dinámico' },
      { src: 'blanco_azul_top.png', label: 'Superior' },
      { src: 'blanco_azul_heel.png', label: 'Talón' }
    ],
    'Blanco-neon': [
      { src: 'shoe_blanco_lima.webp', label: 'Lateral' },
      { src: 'blanco_neon_pair.png', label: 'Con Suela' },
      { src: 'blanco_neon_angle.png', label: 'Dinámico' },
      { src: 'blanco_neon_top.png', label: 'Superior' },
      { src: 'blanco_neon_heel.png', label: 'Talón' }
    ],
    'Negro-rojo': [
      { src: 'shoe_negro_rojo.webp', label: 'Lateral' },
      { src: 'negro_rojo_pair.png', label: 'Con Suela' },
      { src: 'negro_rojo_angle.png', label: 'Dinámico' },
      { src: 'negro_rojo_top.png', label: 'Superior' },
      { src: 'negro_rojo_heel.png', label: 'Talón' }
    ]
  };

  const colorGalleries = window.RoyalColorGalleries || defaultGalleries;
  const colorThumbs = window.RoyalColorThumbs || {};

  let currentColor = 'Blanco-negro';
  let currentAngleIndex = 0;
  let currentSize = '36';
  let currentQty = 1;
  const unitPrice = window.RoyalProductPrice || 159900;

  // DOM Elements
  const mainImage = document.getElementById('mainImage');
  const mainImageWrap = document.getElementById('mainImageWrap');
  const galleryCounter = document.getElementById('galleryCounter');
  const gallerySwipeHint = document.getElementById('gallerySwipeHint');
  const galleryPrevBtn = document.getElementById('galleryPrevBtn');
  const galleryNextBtn = document.getElementById('galleryNextBtn');
  const selectedColorLabel = document.getElementById('selectedColorLabel');
  const selectedSizeLabel = document.getElementById('selectedSizeLabel');
  const colorCards = document.querySelectorAll('.color-card');
  const sizePills = document.querySelectorAll('.size-pill');

  const inputQuantity = document.getElementById('inputQuantity');
  const btnQtyMinus = document.getElementById('btnQtyMinus');
  const btnQtyPlus = document.getElementById('btnQtyPlus');
  const btnCodBuy = document.getElementById('btnCodBuy');

  // Sticky Mobile Elements
  const stickyMobileBar = document.getElementById('stickyMobileBar');
  const stickyBarThumb = document.getElementById('stickyBarThumb');
  const stickyBarModel = document.getElementById('stickyBarModel');
  const stickyBuyBtn = document.getElementById('stickyBuyBtn');

  // COD Modal Elements
  const codModal = document.getElementById('codModal');
  const codModalOverlay = document.getElementById('codModalOverlay');
  const codModalClose = document.getElementById('codModalClose');
  const codFormView = document.getElementById('codFormView');
  const codSuccessView = document.getElementById('codSuccessView');
  const codOrderForm = document.getElementById('codOrderForm');
  const btnCloseSuccess = document.getElementById('btnCloseSuccess');

  const modalProductImg = document.getElementById('modalProductImg');
  const modalSelectedColor = document.getElementById('modalSelectedColor');
  const modalSelectedSize = document.getElementById('modalSelectedSize');
  const modalSelectedQty = document.getElementById('modalSelectedQty');
  const modalOrderTotal = document.getElementById('modalOrderTotal');

  // Currency Formatter (COP)
  function formatCOP(amount) {
    return '$' + amount.toLocaleString('es-CO') + ',00';
  }

  // Update gallery controls visibility
  function updateGalleryUI() {
    const list = colorGalleries[currentColor] || [];

    if (list.length <= 1) {
      if (gallerySwipeHint) gallerySwipeHint.style.display = 'none';
      if (galleryPrevBtn) galleryPrevBtn.style.display = 'none';
      if (galleryNextBtn) galleryNextBtn.style.display = 'none';
      if (galleryCounter) galleryCounter.style.display = 'none';
    } else {
      if (gallerySwipeHint) gallerySwipeHint.style.display = 'flex';
      if (galleryPrevBtn) galleryPrevBtn.style.display = 'flex';
      if (galleryNextBtn) galleryNextBtn.style.display = 'flex';
      if (galleryCounter) galleryCounter.style.display = 'block';
    }
  }

  // Set Angle for current color
  function setAngle(index) {
    const list = colorGalleries[currentColor] || [];
    if (!list || list.length === 0) return;
    if (index < 0) index = list.length - 1;
    if (index >= list.length) index = 0;
    currentAngleIndex = index;

    const angleData = list[currentAngleIndex];
    if (galleryCounter) {
      galleryCounter.textContent = `${currentAngleIndex + 1} / ${list.length}`;
    }

    // Smooth Image transition
    if (mainImage) {
      mainImage.style.opacity = '0.25';
      mainImage.style.transform = 'scale(0.98)';
      setTimeout(() => {
        mainImage.src = angleData.src;
        mainImage.style.opacity = '1';
        mainImage.style.transform = 'scale(1)';
      }, 110);
    }
  }

  // Wire up gallery prev / next buttons
  if (galleryPrevBtn) {
    galleryPrevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const list = colorGalleries[currentColor] || [];
      if (list.length > 1) {
        setAngle(currentAngleIndex - 1);
      }
    });
  }

  if (galleryNextBtn) {
    galleryNextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const list = colorGalleries[currentColor] || [];
      if (list.length > 1) {
        setAngle(currentAngleIndex + 1);
      }
    });
  }

  // Set Color Variant (Triggered by clicking the rectangular color cards!)
  function setColor(colorName) {
    currentColor = colorName;
    currentAngleIndex = 0;

    if (selectedColorLabel) selectedColorLabel.textContent = currentColor;

    // Update rectangular color cards
    colorCards.forEach(card => {
      if (card.dataset.color === currentColor) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });

    updateGalleryUI();
    setAngle(0);

    // Update sticky & modal
    const list = colorGalleries[currentColor];
    const primarySrc = (list && list[0]) ? list[0].src : (colorThumbs[currentColor] || '');
    if (stickyBarThumb && primarySrc) stickyBarThumb.src = primarySrc;
    if (stickyBarModel) {
      stickyBarModel.innerHTML = `${currentColor} • Talla <span id="stickyBarSize">${currentSize}</span>`;
    }
    if (typeof updateSelectedVariant === 'function') updateSelectedVariant();
  }

  // Initialize gallery on load
  updateGalleryUI();
  setAngle(0);

  // Click on rectangular color cards
  colorCards.forEach(card => {
    card.addEventListener('click', () => {
      setColor(card.dataset.color);
    });
  });

  // Size pills click
  sizePills.forEach(pill => {
    pill.addEventListener('click', () => {
      sizePills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      currentSize = pill.dataset.size;
      if (selectedSizeLabel) selectedSizeLabel.textContent = currentSize;
      const stickySizeEl = document.getElementById('stickyBarSize');
      if (stickySizeEl) stickySizeEl.textContent = currentSize;
      if (typeof updateSelectedVariant === 'function') updateSelectedVariant();
    });
  });

  // EasySell Configuration Overrides
  window.ES_QUANTITY_SELECTOR_OVERRIDE = '#selectedQuantity';
  window.ES_VARIANT_SELECTOR_OVERRIDE = '#selectedVariantId';

  // Master Quantity Synchronizer (Syncs UI, Hidden Form Input, Sticky Bar, and EasySell COD Modal)
  function setQuantity(newQty) {
    const parsed = parseInt(newQty, 10);
    currentQty = isNaN(parsed) || parsed < 1 ? 1 : Math.min(10, parsed);

    if (inputQuantity) {
      inputQuantity.value = currentQty;
      inputQuantity.setAttribute('value', currentQty);
    }

    const selQty = document.getElementById('selectedQuantity');
    if (selQty) {
      selQty.value = String(currentQty);
      selQty.setAttribute('value', String(currentQty));
      selQty.dispatchEvent(new Event('change', { bubbles: true }));
      selQty.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Sync any EasySell internal inputs if already rendered in DOM
    document.querySelectorAll('[name="es-quantity-picker"], .quantity-picker-input').forEach(el => {
      if (parseInt(el.value, 10) !== currentQty) {
        el.value = currentQty;
        el.setAttribute('value', String(currentQty));
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    updateTotals();
  }

  // Quantity Handlers
  if (btnQtyMinus) {
    btnQtyMinus.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentQty > 1) {
        setQuantity(currentQty - 1);
      }
    });
  }

  if (btnQtyPlus) {
    btnQtyPlus.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentQty < 10) {
        setQuantity(currentQty + 1);
      }
    });
  }

  if (inputQuantity) {
    inputQuantity.addEventListener('change', () => {
      setQuantity(inputQuantity.value);
    });
  }

  // Listen for changes inside EasySell modal quantity picker to keep theme and modal perfectly synced
  document.addEventListener('input', (e) => {
    if (e.target && (e.target.name === 'es-quantity-picker' || e.target.classList.contains('quantity-picker-input'))) {
      const val = parseInt(e.target.value, 10);
      if (!isNaN(val) && val >= 1 && val !== currentQty) {
        currentQty = Math.min(10, val);
        if (inputQuantity) {
          inputQuantity.value = currentQty;
          inputQuantity.setAttribute('value', currentQty);
        }
        const selQty = document.getElementById('selectedQuantity');
        if (selQty) {
          selQty.value = String(currentQty);
          selQty.setAttribute('value', String(currentQty));
        }
        updateTotals();
      }
    }
  });

  function updateTotals() {
    const total = currentQty * unitPrice;
    if (modalSelectedQty) modalSelectedQty.textContent = currentQty;
    if (modalOrderTotal) modalOrderTotal.textContent = formatCOP(total);
    const stickyPriceVal = document.querySelector('.sticky-price-val');
    if (stickyPriceVal) {
      stickyPriceVal.textContent = formatCOP(total);
    }
  }

  // Touch Swipe Gesture on Gallery (Mobile swipe left/right between angles)
  let touchStartX = 0;
  let touchEndX = 0;

  if (mainImageWrap) {
    mainImageWrap.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mainImageWrap.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
  }

  function handleSwipe() {
    const threshold = 35;
    if (touchEndX < touchStartX - threshold) {
      setAngle(currentAngleIndex + 1);
    } else if (touchEndX > touchStartX + threshold) {
      setAngle(currentAngleIndex - 1);
    }
  }

  // Variant ID Map (All 32 product combinations for EasySell COD)
  const variantMap = {
    "Blanco-negro/36": 44577241006145,
    "Blanco-negro/37": 44577241038913,
    "Blanco-negro/38": 44577241071681,
    "Blanco-negro/39": 44577241104449,
    "Blanco-negro/40": 44577241137217,
    "Blanco-negro/41": 44577241169985,
    "Blanco-negro/42": 44577241202753,
    "Blanco-negro/43": 44577241235521,
    "Blanco-azul/36": 44577241268289,
    "Blanco-azul/37": 44577241301057,
    "Blanco-azul/38": 44577241333825,
    "Blanco-azul/39": 44577241366593,
    "Blanco-azul/40": 44577241399361,
    "Blanco-azul/41": 44577241432129,
    "Blanco-azul/42": 44577241464897,
    "Blanco-azul/43": 44577241497665,
    "Blanco-neon/36": 44577241530433,
    "Blanco-neon/37": 44577241563201,
    "Blanco-neon/38": 44577241595969,
    "Blanco-neon/39": 44577241628737,
    "Blanco-neon/40": 44577241661505,
    "Blanco-neon/41": 44577241694273,
    "Blanco-neon/42": 44577241727041,
    "Blanco-neon/43": 44577241759809,
    "Negro-rojo/36": 44577241792577,
    "Negro-rojo/37": 44577241825345,
    "Negro-rojo/38": 44577241858113,
    "Negro-rojo/39": 44577241890881,
    "Negro-rojo/40": 44577241923649,
    "Negro-rojo/41": 44577241956417,
    "Negro-rojo/42": 44577241989185,
    "Negro-rojo/43": 44577242021953
  };

  function updateSelectedVariant() {
    const input = document.getElementById('selectedVariantId');
    const key = `${currentColor}/${currentSize}`;
    if (input && variantMap[key]) {
      const varId = String(variantMap[key]);
      input.value = varId;
      input.setAttribute('value', varId);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const selQty = document.getElementById('selectedQuantity');
    if (selQty) {
      selQty.value = String(currentQty);
      selQty.setAttribute('value', String(currentQty));
      selQty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // EasySell COD Trigger Function (Reliable & Instant)
  function triggerEasySell(retryCount = 0) {
    updateSelectedVariant();
    setQuantity(currentQty);

    const form = document.getElementById('AddToCartForm');
    if (form) {
      window.ES_CLOSEST_FORM = form;
    }

    const currentVariantId = document.getElementById('selectedVariantId')?.value || '44577241006145';

    // Synchronize Shopify backend cart directly so EasySell cart drawer & modal always reflect the selected quantity
    try {
      if (window.fetch) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [currentVariantId]: currentQty } })
        }).catch(() => {});
      }
    } catch (e) {}

    // 1. EasySell native global opener function
    if (typeof window.openTysloForm === 'function') {
      try {
        window.openTysloForm();
        return true;
      } catch (err) {
        console.warn('openTysloForm error:', err);
      }
    }

    // 2. Direct EasySell Modal Display
    const esModal = document.getElementById('easysell-modal');
    if (esModal) {
      try {
        esModal.style.setProperty('display', 'block', 'important');
        document.querySelectorAll('html, body').forEach(n => {
          n.style.overflow = 'hidden';
        });
        return true;
      } catch (e) {}
    }

    // 3. Query any internal EasySell button and click it
    const candidates = [
      '.es-popup-button:not(#btnCodBuy):not(#stickyBuyBtn)',
      '.es-button:not(#btnCodBuy):not(#stickyBuyBtn)',
      '.easysell-btn:not(#btnCodBuy):not(#stickyBuyBtn)',
      '[id*="easysell"] button:not(#btnCodBuy):not(#stickyBuyBtn)',
      '.es-checkout-btn',
      '.es-cta-btn'
    ];
    for (const sel of candidates) {
      const btn = document.querySelector(sel);
      if (btn && btn !== stickyBuyBtn && btn !== btnCodBuy) {
        try {
          btn.click();
          return true;
        } catch (e) {}
      }
    }

    // 4. EasySell app object listener fallback
    if (window.easysellApp && typeof window.easysellApp.popupListner === 'function') {
      try {
        window.easysellApp.popupListner();
        return true;
      } catch (e) {}
    }
    if (window.EasySell && typeof window.EasySell.open === 'function') {
      try {
        window.EasySell.open();
        return true;
      } catch (e) {}
    }

    // 5. If EasySell script is still loading from CDN, retry for up to 1.5s
    if (retryCount < 10) {
      setTimeout(() => triggerEasySell(retryCount + 1), 150);
      return true;
    }

    // 6. Final safety fallback
    if (form) form.submit();
    return false;
  }

  // Check if EasySell rendered and suppress duplicate auto-injected buttons on product page
  function checkEasySellPresence() {
    // Suppress ONLY duplicate buttons on the product page (never touch the checkout modal)
    const esDuplicates = document.querySelectorAll(
      '.buy-action-area .es-popup-button, .product-info-column .es-popup-button, form#AddToCartForm .es-popup-button, .product-form-base .es-popup-button, .es-sticky, .es-sticky-bottom, .es-sticky-desktop, [class*="es-sticky"]'
    );
    esDuplicates.forEach(el => {
      if (el.closest('#easysell-modal') || el.closest('#easysell') || el.closest('.es-modal')) {
        return; // NEVER touch the checkout form!
      }
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
    });

    // Ensure the submit button inside the modal is ALWAYS active & visible
    const modalSubmitBtn = document.querySelector('#easysell-modal .es-button, #easysell-modal .es-cta-btn, #easysell-modal button[type="submit"], #easysell .es-button');
    if (modalSubmitBtn) {
      modalSubmitBtn.style.setProperty('display', 'flex', 'important');
      modalSubmitBtn.style.setProperty('visibility', 'visible', 'important');
      modalSubmitBtn.style.setProperty('opacity', '1', 'important');
      modalSubmitBtn.style.setProperty('pointer-events', 'auto', 'important');
    }

    // Guarantee OUR primary button is ALWAYS visible and never disappears!
    if (btnCodBuy) {
      btnCodBuy.style.setProperty('display', 'flex', 'important');
      btnCodBuy.style.setProperty('visibility', 'visible', 'important');
      btnCodBuy.style.setProperty('opacity', '1', 'important');
    }

    // Ensure EasySell Departamento select container is styled and has focus handling
    const provSelect = document.querySelector('#easysell select#es-province, #easysell .es-province-container select, #easysell select[name="province"], #easysell-modal select');
    if (provSelect) {
      const container = provSelect.closest('.es-province-container, .es-input-container, .es-input-column');
      if (container && !container.classList.contains('es-styled-select-container')) {
        container.classList.add('es-styled-select-container');
        provSelect.addEventListener('focus', () => container.classList.add('is-focused'));
        provSelect.addEventListener('blur', () => container.classList.remove('is-focused'));
      }
    }
  }
  checkEasySellPresence();
  setTimeout(checkEasySellPresence, 400);
  setTimeout(checkEasySellPresence, 1200);
  setTimeout(checkEasySellPresence, 2500);

  // CTA 1: Main Product Buy Button
  if (btnCodBuy) {
    btnCodBuy.addEventListener('click', (e) => {
      e.preventDefault();
      triggerEasySell();
    });
  }

  // CTA 2: Mobile Sticky Bar Buy Button
  if (stickyBuyBtn) {
    stickyBuyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      triggerEasySell();
    });
  }

  // Dynamic Shipping Timeline Dates (Spanish Colombian format)
  function initDynamicDates() {
    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'];
    const now = new Date();

    const d1 = new Date(now);
    const d2 = new Date(now);
    d2.setDate(d2.getDate() + 1);

    const d3Start = new Date(now);
    d3Start.setDate(d3Start.getDate() + 2);

    const d3End = new Date(now);
    d3End.setDate(d3End.getDate() + 5);

    const strD1 = `${d1.getDate()} ${months[d1.getMonth()]}`;
    const strD2 = `${d2.getDate()} ${months[d2.getMonth()]}`;
    const strD3 = `${d3Start.getDate()} - ${d3End.getDate()} ${months[d3End.getMonth()]}`;

    const dateEl1 = document.getElementById('checkpointDate1');
    const dateEl2 = document.getElementById('checkpointDate2');
    const dateEl3 = document.getElementById('checkpointDate3');

    if (dateEl1) dateEl1.textContent = strD1;
    if (dateEl2) dateEl2.textContent = strD2;
    if (dateEl3) dateEl3.textContent = strD3;
  }
  initDynamicDates();

  // Sticky Bottom Bar Setup & Scroll Trigger
  const stickyBar = document.getElementById('stickyBottomBar') || document.getElementById('stickyMobileBar');
  const stickyProductInfo = document.getElementById('stickyBarProductInfo');

  // Smooth scroll back to options if user taps shoe info in the sticky bar
  if (stickyProductInfo) {
    stickyProductInfo.addEventListener('click', () => {
      const targetArea = document.getElementById('buyActionArea') || document.getElementById('product');
      if (targetArea) {
        targetArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  // Sticky Bar Visibility on Scroll (Mobile & Desktop)
  window.addEventListener('scroll', () => {
    const triggerEl = document.getElementById('buyActionArea') || btnCodBuy;
    if (stickyBar && triggerEl) {
      const rect = triggerEl.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    }
  }, { passive: true });

  // Scroll to description on rating click
  const ratingWrap = document.getElementById('scrollToReviews');
  if (ratingWrap) {
    ratingWrap.addEventListener('click', () => {
      const descSec = document.getElementById('description');
      if (descSec) {
        descSec.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Technical Specs Accordion Interaction
  const specsButtons = document.querySelectorAll('.specs-accordion-btn');
  specsButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.specs-accordion-item');
      if (item) {
        const isOpen = item.classList.contains('is-open');
        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  // Polish popup: translate Portuguese text, polish the 3 offer badges, and keep alignment clean
  function polishEasySellPopup() {
    const modal = document.getElementById('easysell-modal') || document.querySelector('.es-modal');
    if (!modal) return;

    // 1. Colombian Spanish text corrections (Portuguese defaults in EasySell)
    modal.querySelectorAll('.label-title, .es-discount-line, .es-total-section, .es-tax-message').forEach(el => {
      if (el.textContent.includes('Desconto')) {
        el.innerHTML = el.innerHTML.replace(/Desconto/g, 'Descuento');
      }
      if (el.textContent.includes('Todos os impostos')) {
        el.textContent = 'Impuestos y envío incluidos';
      }
    });

    // Color "Gratis" shipping text in green and standardize Spanish spelling
    modal.querySelectorAll('div, span, p').forEach(el => {
      if (el.children.length === 0) {
        const t = el.textContent.trim();
        if (t === 'Grátis' || t === 'Gratis') {
          el.textContent = 'Gratis';
          el.style.setProperty('color', '#00A859', 'important');
          el.style.setProperty('font-weight', '700', 'important');
        }
      }
    });

    modal.querySelectorAll('.es-label-column label, .es-form-group label, .es-form-label').forEach(label => {
      if (label.textContent.includes('Cidade')) {
        label.innerHTML = label.innerHTML.replace(/Cidade/g, 'Ciudad');
      }
    });

    modal.querySelectorAll('input[placeholder*="Cidade"]').forEach(input => {
      input.placeholder = input.placeholder.replace(/Cidade/g, 'Ciudad');
    });

    // Ensure Nombre input has visible placeholder "Nombre" matching other fields
    modal.querySelectorAll('input').forEach(input => {
      const parent = input.closest('.es-group, .es-form-group, .form-group') || input.parentElement?.parentElement;
      const labelText = parent ? (parent.querySelector('label, .es-label')?.textContent || '') : '';
      const hasPersonIcon = input.parentElement ? input.parentElement.querySelector('.bi-person, .bi-person-circle, .bi-person-fill') : null;

      if (labelText.includes('Nombre') || hasPersonIcon || input.name === 'name' || input.id === 'name' || input.getAttribute('autocomplete') === 'name') {
        if (!input.placeholder || input.placeholder.trim() === '') {
          input.placeholder = 'Nombre';
        }
      }
    });

    // 2. The 3 Offer Badges (Exact design requested by user)
    const offerCards = modal.querySelectorAll('.es-qo-container');
    if (!offerCards.length) return;

    offerCards.forEach(card => {
      const titleEl = card.querySelector('.mb-1');
      if (!titleEl) return;
      const text = titleEl.textContent.trim();

      // Ensure price container is marked with .es-price-wrapper and numbers are green
      const priceEl = card.querySelector('.es-o-p');
      if (priceEl) {
        priceEl.style.setProperty('color', '#00A859', 'important');
        if (priceEl.parentElement) {
          priceEl.parentElement.classList.add('es-price-wrapper');
        }
      }

      // Clean Typography Subtitle (pure elegance, zero bulky boxes)
      let subtitleEl = card.querySelector('.es-tier-subtitle');
      if (!subtitleEl) {
        subtitleEl = document.createElement('div');
        subtitleEl.className = 'es-tier-subtitle';
        titleEl.after(subtitleEl);
      }

      // Hide any legacy bulky badges
      const legacyBadge = card.querySelector('.es-offer-badge, .offer-badge');
      if (legacyBadge) {
        legacyBadge.style.setProperty('display', 'none', 'important');
      }

      // Card 1: 1 Par
      if (text === '1 Par' || text.startsWith('1 ')) {
        card.setAttribute('data-tier', '1');
        subtitleEl.textContent = '50% de descuento';
        const oldTag = card.querySelector('.es-floating-tag');
        if (oldTag) oldTag.remove();
      }

      // Card 2: 2 Pares (Hero with floating MÁS VENDIDO tag)
      else if (text === '2 Pares' || text.startsWith('2 ')) {
        card.setAttribute('data-tier', '2');
        subtitleEl.textContent = 'Ahorras $50.000 COP';
        let tagEl = card.querySelector('.es-floating-tag');
        if (!tagEl) {
          tagEl = document.createElement('div');
          tagEl.className = 'es-floating-tag';
          card.appendChild(tagEl);
        }
        tagEl.textContent = 'MÁS VENDIDO';
      }

      // Card 3: 3 Pares ($110.000 COP savings)
      else if (text === '3 Unidades' || text === '3 Pares' || text.startsWith('3 ')) {
        titleEl.textContent = '3 Pares';
        card.setAttribute('data-tier', '3');
        subtitleEl.textContent = 'Ahorras $110.000 COP';
        const oldTag = card.querySelector('.es-floating-tag');
        if (oldTag) oldTag.remove();
      }
    });
  }

  // Trigger polish only on user interaction (zero background loops, zero continuous intervals)
  document.addEventListener('click', (e) => {
    if (e.target.closest('#btnCodBuy') || e.target.closest('#stickyBuyBtn') || e.target.closest('#easysell-modal') || e.target.closest('.es-qo-container')) {
      setTimeout(polishEasySellPopup, 100);
      setTimeout(polishEasySellPopup, 350);
      setTimeout(polishEasySellPopup, 700);
    }
  });

  document.addEventListener('focusin', (e) => {
    if (e.target.closest('#easysell-modal')) {
      polishEasySellPopup();
    }
  });
});



